import Tag from '@/modules/tag'

export default {

    setPage: function (vue, page, meta = true) {

        if (meta) {

            vue.$store.dispatch('setPage', page)
        }
        Tag.pageViewAmplitude(vue, page)
    }

}
